import { useAuth0 } from '../auth/authWrapper';

export default {
  install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  },
};
